import Vue from 'vue';
import draggable from 'vuedraggable';
import spotWallet from '@/components/pages/mainPage/sidebar/items/spotWallet.vue';
import currencyWallet from '@/components/pages/mainPage/sidebar/items/currencyWallet.vue';
import internalTransfers from '@/components/pages/mainPage/sidebar/items/internalTransfers.vue';
import dropWrapper from '@/components/global/drop-wrapper/index.vue';
export default Vue.extend({
    props: {
        scrollingDown: {
            type: Boolean,
            required: false,
            default: false
        },
        scrollPosition: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data: () => ({
        toDragList: [
            { name: 'spotWallet', id: 0, opened: true },
            { name: 'currencyWallet', id: 1, opened: true },
            { name: 'internalTransfers', id: 2, opened: true }
        ],
        scrollTo: {
            x: '0%',
            y: '0%'
        }
    }),
    watch: {
        toDragList: {
            handler: function (value) {
                localStorage.setItem('mainService-toDragList', JSON.stringify(value));
            },
            deep: true
        },
        scrollPosition: {
            handler: function () {
                const currentPosition = parseFloat(this.scrollTo.y);
                if (currentPosition <= 0)
                    this.scrollTo.y = '0%';
                if (currentPosition >= 100)
                    this.scrollTo.y = '100%';
                const value = this.scrollingDown ? parseFloat(this.scrollTo.y) + 20 : parseFloat(this.scrollTo.y) - 20;
                this.scrollTo.y = `${String(value)}%`;
            }
        }
    },
    methods: {
        handleDragStart() {
            document.body.classList.add('grabbing');
        },
        handleDragEnd() {
            document.body.classList.remove('grabbing');
        }
    },
    components: {
        draggable,
        spotWallet,
        currencyWallet,
        internalTransfers,
        dropWrapper
    },
    created() {
        const toParse = localStorage.getItem('mainService-toDragList');
        const parsed = JSON.parse(toParse);
        if (parsed)
            this.toDragList = parsed;
    }
});
